import { useCallback, useEffect, useState } from 'react'
import {
  CheckBodProp,
  RecordDetail,
  RecordsStats,
} from '@user/features/GlobalSearch/FilterDrawer/typings'
import { useSelector } from 'react-redux/es/hooks/useSelector'
import { selectAllCustomizedResultsSettings } from '@user/store/globalSearch'

const getCheckBoxState = (
  isDraftLeadAvailable: boolean,
  isDraftLeadSelected: boolean,
  isLeadSelected: boolean,
  isOppSelected: boolean,
): CheckBodProp[] => {
  return [
    {
      key: 'pendingLead',
      available: isDraftLeadAvailable,
      checked: isDraftLeadSelected,
    },
    {
      key: 'lead',
      available: true,
      checked: isLeadSelected,
    },
    {
      key: 'opportunity',
      available: true,
      checked: isOppSelected,
    },
  ]
}

export function useRecordDetails() {
  const [recordDetails, setRecordDetails] = useState<RecordDetail[]>([])
  const customizedSettings = useSelector(selectAllCustomizedResultsSettings)
  const [recordStats, setRecordStats] = useState<RecordsStats>({
    lead: 0,
    opportunity: 0,
    pendingLead: 0,
  })

  const onChangeCheckBox = useCallback(
    (itemIndex: number, checkBoxIndex: number) => {
      const state = [...recordDetails]
      const checkBox = state[itemIndex].checkBoxes[checkBoxIndex]
      checkBox.checked = !checkBox.checked

      setRecordDetails(state)
    },
    [recordDetails],
  )

  useEffect(() => {
    let lead = 0,
      opportunity = 0,
      pendingLead = 0
    recordDetails.map((item) => {
      if (item.checkBoxes[0].checked) pendingLead++
      if (item.checkBoxes[1].checked) lead++
      if (item.checkBoxes[2].checked) opportunity++
    })
    setRecordStats({ pendingLead, lead, opportunity })
  }, [recordDetails])

  useEffect(() => {
    const records: RecordDetail[] = customizedSettings.map((setting) => {
      return {
        id: setting.id,
        title: setting.settingName,
        checkBoxes: getCheckBoxState(
          setting.isDraftLeadAvailable,
          setting.isDraftLeadSelected,
          setting.isLeadSelected,
          setting.isOppSelected,
        ),
      }
    })
    setRecordDetails(records)
  }, [customizedSettings])

  return { recordDetails, onChangeCheckBox, recordStats }
}
